import React, { useContext } from "react"
import { BadgeElement as TBadgeElement } from "sharedTypes/badge"
import { EventData, GuestData } from "../utils/badgeDataResolver"
import { renderElement } from "../elementTypes"
import { EDITOR_RESOLUTION } from "../utils/constants"
import { BadgeSelectionContext } from "../contexts/BadgeSelectionContext"
import { BadgeElementContext } from "../contexts/BadgeElementContext"

type Props = {
  element: TBadgeElement
  scaleFactor?: number
  guestData?: GuestData
  eventData?: EventData
}

const BadgeElement = ({
  element,
  scaleFactor = EDITOR_RESOLUTION,
  guestData,
  eventData,
}: Props) => {
  // Get editing capabilities from context (null in preview mode, available in editor mode)
  const selectionContext = useContext(BadgeSelectionContext)
  const elementContext = useContext(BadgeElementContext)

  // Compute if this specific element is being edited
  const isEditing = selectionContext?.inlineEditingElementId === element.id
  const handleTextChange = elementContext
    ? (newText: string) => {
      elementContext.handleElementChange(element.id, { text: newText })
    }
    : undefined
  const stopInlineEditing = selectionContext?.stopInlineEditing

  return (
    <>
      {renderElement(element, {
        scaleFactor,
        guestData,
        eventData,
        isEditing,
        onTextChange: handleTextChange,
        onStopEditing: stopInlineEditing,
      })}
    </>
  )
}

export default BadgeElement
